export default "__VITE_ASSET__HifpjvBK__"